import { render, staticRenderFns } from "./Tramo3DetalleModal.vue?vue&type=template&id=7d671ca0"
import script from "./Tramo3DetalleModal.vue?vue&type=script&lang=js"
export * from "./Tramo3DetalleModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports